import { render, staticRenderFns } from "./GlobalProgress.vue?vue&type=template&id=55594e50&scoped=true"
import script from "./GlobalProgress.vue?vue&type=script&lang=js"
export * from "./GlobalProgress.vue?vue&type=script&lang=js"
import style0 from "./GlobalProgress.vue?vue&type=style&index=0&id=55594e50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55594e50",
  null
  
)

export default component.exports